<template>
  <div id="app">
    <div>
      <img class="home_banner" src="../../../static/img/img_news_detail_bg.png" />
      <div class="father-div">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="6" :lg="6">
            <!-- <div class="logo-div">
            <img :src="Detail.cover" />
          </div> -->
            <div class="back-div" @click="back()">
              <p>返回列表</p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="18" :lg="18">
            <div class="title-div">
              <p class="subtitle">{{ Detail.title }}</p>
              <p class="title">发布日期：{{ Detail.activityTime }}</p>
              <div class="line"></div>
            </div>
            <div v-html="Detail.content" class="content"></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      Detail: [],
    };
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
  },
  mounted() {
    this.Init();
  },
  methods: {
    Init() {
      window.scrollTo(0, 0);
      this.getDetail();
    },
    navto(id) {
      window.location.href = "/News/NewsDetail/id=" + id;
    },
    back() {
      this.$router.back();
    },
    getDetail() {
      this.$axios
        .get("api/activity/info/" + window.location.href.split("id=")[1])
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.Detail = response.data.data;
              document.title = this.Detail.title;
              this.getInfo2(this.Detail.type);
            }
          }.bind(this)
        );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.father-div {
  padding: 9rem 24rem;
}

.logo-div {
  padding: 1rem;
  width: 32rem;
  height: 9rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-radius: 6px;
  -webkit-box-shadow: 3px 3px 10px 1px rgba(100, 100, 100, 0.1);
  box-shadow: 3px 3px 10px 1px rgba(100, 100, 100, 0.1);

  img {
    height: 100%;
  }
}

.back-div {
  cursor: pointer;
  margin-top: 0;
  width: 15rem;
  border-radius: 5rem;
  color: white;
  background: var(--COLORE14B3E3);
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);

  p {
    margin: 0;
    font-size: 1.8rem;
  }
}

.title-div {
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .subtitle {
    color: var(--COLORE3B);
    font-family: bold;
    font-size: 2.4rem;
  }

  .title {
    color: var(--COLOREA2);
    font-family: regular;
    font-size: 1.6rem;
    line-height: 1;
    margin: 0;
  }
}

.line {
  margin-top: 1.5rem;
  margin-bottom: 3.5rem;
  height: 1px;
  width: 100%;
  background: var(--COLOREAB);
}

.content {
  color: var(--COLORE47);
  font-family: regular;
  font-size: 1.8rem;
  text-align: start;
  line-height: 1.5;

  p {
    margin: 0;
  }
}

.heading {
  margin: 10rem 0 0;
  padding: 5rem 0 0 0;
  font-size: 3rem;
  color: var(--textBlue);
  text-align: center;
  font-family: bold;
}

.sub_heading {
  font-size: 1.6rem;
  color: var(--textBlue);
  text-align: center;
}

.tv_content {
  margin: auto;
  width: 60%;
  font-size: 1.6rem;
  color: #4c4948;
  text-align: center;
  line-height: 2rem;
}

.html_div {
  width: 60%;
  margin: auto;
  line-height: 3rem;
  text-align: left;
  // font-size: 1.2rem;
  // font-family: light;
}
@media screen and (max-width: 1200px) {
  .father-div{
    padding: 9rem 1rem;
    height: 100vh;
  }
  .el-row{
    display: flex;
    flex-direction: column-reverse;
  }
}
</style>
